<footer>
    &copy; All rights reserved 2025
</footer>
